import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * NavigationListener component
 *
 * Listens for custom navigation events from browser notifications (both foreground and background)
 * and uses React Router to navigate internally without causing a full page reload.
 *
 * This is critical for features like VOIP calls where a page reload would end the active call.
 */
const NavigationListener = () => {
	const navigate = useNavigate();

	useEffect(() => {
		// Handler for custom navigation events from foreground notifications
		const handleNavigationEvent = (event) => {
			const { path } = event.detail;
			if (path) {
				navigate(path);
			}
		};

		// Handler for messages from service worker (background notifications)
		const handleServiceWorkerMessage = (event) => {
			if (event.data?.type === 'CHEKKIT_NAVIGATE_TO_PATH') {
				const { path } = event.data;
				if (path) {
					navigate(path);
				}
			}
		};

		// Listen for custom navigation events from foreground notifications
		window.addEventListener('chekkit-navigate', handleNavigationEvent);

		// Listen for messages from service worker for background notifications
		navigator.serviceWorker?.addEventListener(
			'message',
			handleServiceWorkerMessage
		);

		return () => {
			window.removeEventListener(
				'chekkit-navigate',
				handleNavigationEvent
			);
			navigator.serviceWorker?.removeEventListener(
				'message',
				handleServiceWorkerMessage
			);
		};
	}, [navigate]);

	// This component doesn't render anything
	return null;
};

export default NavigationListener;
